import { CommandPayload } from '../../interfaces/commands/command-payload';
import { PrimeExpressionParserPayload } from '../../interfaces/prime-expression-parser-payload';
import { FlowType } from '../../types/flow-types';
import { FlowParameter } from '../flow-config/flow-parameter';
import { SftpConnectorBase } from './sftp-connector-base';

export class SftpTestConnectionPayload implements PrimeExpressionParserPayload {
	sftpConnectorBase: SftpConnectorBase;
	commandPayload: CommandPayload;
	flowID: string;
	flowType: FlowType;
	flowParameters: FlowParameter[];

	constructor(
		sftpConnectorBase: SftpConnectorBase,
		payload: CommandPayload,
		flowID: string,
		flowType: FlowType,
		flowParameters: FlowParameter[]
	) {
		this.sftpConnectorBase = sftpConnectorBase;
		this.commandPayload = payload;
		this.flowID = flowID;
		this.flowType = flowType;
		this.flowParameters = flowParameters;
	}
}
